import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import _IconMenuFold from "@arco-design/web-react/icon/react-icon/IconMenuFold";
import _IconMenuUnfold from "@arco-design/web-react/icon/react-icon/IconMenuUnfold";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconLeft from "@arco-design/web-react/icon/react-icon/IconLeft";
import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import styles from './style/index.module.less';
export default function GuideLayout({
  title,
  firstQuestion,
  sections,
  children
}) {
  const [activeSection, setActiveSection] = useState(sections[0]?.id || '');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const history = useHistory();
  const handleMenuClick = key => {
    setActiveSection(key);
    const el = document.getElementById(key);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  // 监听滚动，自动高亮当前章节
  useEffect(() => {
    const contentEl = document.getElementById('guide-content');
    if (!contentEl) return;
    const handleScroll = () => {
      const sectionEls = sections.map(s => document.getElementById(s.id)).filter(Boolean);
      let current = sections[0]?.id || '';
      for (const el of sectionEls) {
        if (el.offsetTop - contentEl.scrollTop <= 100) {
          current = el.id;
        }
      }
      setActiveSection(current);
    };
    contentEl.addEventListener('scroll', handleScroll);
    return () => contentEl.removeEventListener('scroll', handleScroll);
  }, [sections]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['guide-layout']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['guide-header']
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    icon: /*#__PURE__*/React.createElement(_IconLeft, null),
    onClick: () => history.push('/help')
  }, "\u8FD4\u56DE\u5E2E\u52A9\u4E2D\u5FC3"), /*#__PURE__*/React.createElement(Link, {
    to: "/help/overview",
    className: styles['guide-overview-link']
  }, "\u4E1A\u52A1\u5168\u666F\u56FE")), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-shell']
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles['guide-toc']} ${sidebarCollapsed ? styles['guide-toc-collapsed'] : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['guide-toc-header']
  }, /*#__PURE__*/React.createElement("h3", null, title), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    size: "small",
    icon: sidebarCollapsed ? /*#__PURE__*/React.createElement(_IconMenuUnfold, null) : /*#__PURE__*/React.createElement(_IconMenuFold, null),
    onClick: () => setSidebarCollapsed(!sidebarCollapsed),
    className: styles['guide-toc-toggle']
  })), !sidebarCollapsed && /*#__PURE__*/React.createElement(_Menu, {
    selectedKeys: [activeSection],
    onClickMenuItem: handleMenuClick,
    style: {
      width: '100%'
    }
  }, sections.map(s => /*#__PURE__*/React.createElement(_Menu.Item, {
    key: s.id
  }, s.label)))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-content'],
    id: "guide-content"
  }, /*#__PURE__*/React.createElement("h1", {
    className: styles['guide-title']
  }, title), firstQuestion && /*#__PURE__*/React.createElement("div", {
    className: styles['guide-first-question']
  }, firstQuestion), children)));
}